import { render, staticRenderFns } from "./corporateGovernanceMain.vue?vue&type=template&id=1ed7f336&scoped=true"
import script from "./corporateGovernanceMain.vue?vue&type=script&lang=js"
export * from "./corporateGovernanceMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed7f336",
  null
  
)

export default component.exports